import CardDefault from "components/Cards/CardDefault";
import { Flex, Text, Spinner } from "@chakra-ui/react";
import { DashboardManutencao } from "core/features/manutencao/typings";
import moment from "moment";
import { Empty } from "antd";
import history from "infra/helpers/history";

interface ProximasManutencoesProps {
  data: DashboardManutencao | undefined;
  loading?: boolean;
}

export default function ProximasManutencoes({
  data,
  loading,
}: ProximasManutencoesProps) {
  return (
    <CardDefault
      onClick={() => history.push("/administracao/manutencao")}
      cursor="pointer"
    >
      <Flex mb={4}>
        <Text fontSize="20px">Próximas manutenções</Text>
      </Flex>

      {loading ? (
        <Spinner size="xl" color="primary" alignSelf="center" margin="auto" />
      ) : null}

      {!loading && !data?.proximas?.length ? <Empty /> : null}

      {!loading && data?.proximas?.length
        ? data?.proximas?.map((v) => (
            <Flex
              flexDirection="column"
              key={v.id}
              py={2}
              borderBottomColor="gray.500"
              borderBottomWidth={1}
            >
              <Text>
                <Text fontWeight="bold"> {moment(v.data).format("DD/MM")}</Text>
                {v.equipamentos}
              </Text>
              <Text fontWeight="medium" fontSize={12}>
                {v.planoManutencao}
              </Text>
            </Flex>
          ))
        : null}
    </CardDefault>
  );
}
